import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  DataTypeProvider,
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';

import MoneyFormat from './format/MoneyFormat.js';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

const getRowId = row => row.id;

const columns = [
  { name: 'id', title: 'ID' },
  { name: 'passName', title: 'Pass' },
  { name: 'adjustment', title: 'ADJ' },
  { name: 'transactionDate', title: 'Date' },
  { name: 'desc', title: 'Description' },
];
const columnExtensions = [
  { columnName: 'id', width: 200 },
  { columnName: 'passName', width: 200 },
  { columnName: 'adjustment', width: 70 , align: 'right'},
  { columnName: 'transactionDate', width: 160 },
];

const DateTypeProvider = () => (
  <DataTypeProvider
    for={['transactionDate']}
    formatterComponent={({ value }) => value ? moment(value.toDate()).format('lll') : ''}
  />
);

const AdjTypeProvider = () => (
  <DataTypeProvider
    for={['adjustment']}
    formatterComponent={({ value }) => (value > 0 ? '+' : '') + value}
  />
);

const DescTypeProvider = () => (
  <DataTypeProvider
    for={['desc']}
    formatterComponent={({ column, row, value }) =>
      row.deskTransactionId ?
      (row.adjustment < 0 ? 'Consumed' : 'Used') + ' in desk transaction: ' + row.deskTransactionId :
      isNumeric(row.paymentAmount) && row.adjustment > 0 ?
      <MoneyFormat displayType='text' value={row.paymentAmount} prefix={'Bought pass for '} /> :
      null
    }
  />
);

class PassTransactionDialog extends Component {
  state = {
    open: this.props.open,
    rows: [],
  };

  queryPassTransaction = (userId) => {
    if (userId) {
      firebase.firestore()
        // .collection("users")
        // .doc(userId)
        .collection("passTransaction")
        .where("userId", "==", userId)
        .get()
        .then(querySnapshot => {
          var rows = this.state.rows;
          querySnapshot.docChanges().forEach(function(change) {
            if (change.type === "added" || change.type === "modified") {
              let data = change.doc.data();
              data.id = change.doc.id;
              data.passName = this.props.passes.find(element => {return element.id === data.passId}).name;

              let index = rows.findIndex(function(element) {
                return element.id === change.doc.id;
              });
              if (index === -1) {
                rows.push(data);
              } else {
                rows[index] = data;
              }
            }
          }.bind(this));
          this.setState({
            rows: Array.from(rows),
          });
        });
    }
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        this.setState({
          open: nextProps.open,
          rows: [],
        });
        this.queryPassTransaction(nextProps.userId);
      } else {
        this.setState({ open: nextProps.open, });
      }
    }
  }

  render() {
    return (
      <Dialog
        maxWidth="lg"
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Passes Transactions</DialogTitle>
        <DialogContent style={{ paddingTop: 3 }}>

          <Paper>
            <Grid
              rows={this.state.rows}
              getRowId={getRowId}
              columns={columns}>

              <DateTypeProvider />
              <AdjTypeProvider />
              <DescTypeProvider />

              {/* Sorting */}
              <SortingState
                defaultSorting={[ {columnName: 'transactionDate', direction: 'desc'}, ]} />
              <IntegratedSorting />

              {/* Filter */}
              <FilteringState />
              <IntegratedFiltering />

              <VirtualTable columnExtensions={columnExtensions} />
              <TableHeaderRow showSortingControls />
              <TableFilterRow />

            </Grid>
          </Paper>

        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

PassTransactionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  userId: PropTypes.string,
  passes: PropTypes.array.isRequired,
};

export default PassTransactionDialog;
